module.exports = __webpack_public_path__ + "img/EgyptTechCamelRider3_ua.36800f04.webp";